import { BaseMutations } from '@/store/base-mutations';
import { Reports } from '@/modules/reports/types';
import ReportsServiceState from './state';

export default class ReportsServiceMutations extends BaseMutations<ReportsServiceState> {
  SET_SERVICES(services: Reports.ServiceActivity[]) {
    this.state.services = services;
  }

  SET_YEARS(years: number[]) {
    this.state.years = years;
  }

  SET_ORGANIZATION(organizations: Reports.Organization[] | [] | any) {
    this.state.organizations = organizations;
  }

  UPD_FILTER_VALUE({ quarter, year, organization_ids } : {quarter: number| null, year: number | null, organization_ids: [] }) {
    this.state.filters.year = year;
    this.state.filters.quarter = quarter;
    this.state.filters.organization_ids = organization_ids;
  }

  UPD_IS_DOWNLOAD(is_download: boolean) {
    this.state.is_download = is_download;
  }

  TOGGLE_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }

  TOGGLE_IS_DOWNLOAD_LOADING(toggle: boolean) {
    this.state.is_download_loading = toggle;
  }
}
